<template>
	<div id="model" v-loading="loading" class="gcardfr">
		<el-row :gutter="0" class>
			<el-col :span="16">
				<el-button size="small" type="primary" icon="el-icon-plus"
					@click="addMd">添加渠道商</el-button>
			</el-col>
		</el-row>
		<el-table ref="multipleTable" class="gtbtop" tooltip-effect="dark" :data="tableData" style="width: 100%">
			<el-table-column prop="agentName" :label="$t('terminal.app_distributor')" width></el-table-column>
			<el-table-column prop="deviceProvince" label="所属省份" ></el-table-column>
			<el-table-column prop="deviceCity" label="所属城市" width></el-table-column>
			<el-table-column prop="name" :label="$t('app_operation')" width="130">
				<template slot-scope="scope">
					<el-button type="text" @click="editMd(scope.row)">{{ $t('app_edit') }}</el-button>
					<label class="opbline">|</label>
					<el-button @click="delRow(scope.row.id)" type="text"
						class="opdcolor">{{ $t('app_delete') }}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<Pages class="gpages" :cpage="page" :ctotal="total" :config="pconfig"></Pages>

		<el-dialog class="gstdia" :title="isEdit? $t('model.edit_model') : $t('model.add_model')"
			:visible.sync="showDia" @close="closeDia">
			<el-form :model="aform" :rules="rules"  ref="ruleForm" >
				<el-form-item :label="$t('terminal.app_distributor')" :label-width="$formlbWidth"  prop="clientKey" >
					<el-select filterable v-model="aform.clientKey" :disabled="isEdit"  clearable style="width: 100%;"
						:placeholder="$t('app_select')" @change="onChange">
						<el-option v-for="item in mech_list" :key="item.agentId" :label="item.agentName"
							:value="item.clientKey">
						</el-option>
					</el-select>
				</el-form-item>
				
				
				<el-form-item label="所属省份" :label-width="$formlbWidth" prop="deviceProvince" >
					<el-input v-model="aform.deviceProvince" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="所属城市" :label-width="$formlbWidth"  prop="deviceCity">
					<el-input v-model="aform.deviceCity" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth">
					<el-button @click="closeDia">{{ $t("app_cancel") }}</el-button>
					<el-button   type="primary" @click="makeRqs">{{ $t("app_sure") }}</el-button>
				</el-form-item>
				
				
				
			</el-form>
			<!-- <div slot="footer" class="dialog-footer">        
      </div>-->
		</el-dialog>
	</div>
</template>

<style>
</style>

<script>
	import Pages from "@/components/Pages.vue";
	import Merchant from "@/components/Merchant.vue";
	export default {
		data() {
			return {
				agentName: "",
				pconfig: "",
				tableData: [],
				mech_list:[],
				isEdit: false,
				showDia: false,
				aform: {
				},
				optionsProType: [{
						TypeName: this.$t('model.self_tube'),
						productType: "0"
					},
					{
						TypeName: this.$t('model.other_manage'),
						productType: "1"
					}
				],
				page: 1,
				total: 0,
				loading: false,
				 rules: {
				  clientKey: [
				    { required: true, message: '请选择', trigger: 'blur' }
				  ],
				  deviceProvince: [
				    { required: true, message: '请输入内容', trigger: 'blur' }
				  ],
				  deviceCity: [
				    { required: true, message: '请输入内容', trigger: 'blur' }
				  ],
				  productType: [
				    { required: true, message: '请选择', trigger: 'blur' }
				  ]
				}
			};
		},
		components: {
			Pages,
			Merchant,
		},
		computed: {
			addMdRqDis() {
				var form = this.aform;
				if (form.model) {
					return false;
				} else {
					return true;
				}
			}
		},
		methods: {
			delRqs(id) {
				this.loading = true;
				this.$delModel(
					id,
					res => {
						this.loading = false;
						if (res.status == 200) {
							this.getList();
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
			},
			// batchDel () {
			//   var arr = []
			//   this.sRows.forEach(item => {
			//     arr.push(item.id)
			//   })
			//   this.delRow(arr.toString())
			// },
			delRow(aid) {
				this.$showMsgBox(
					this.$t('app_delete_question'),
					() => {
						this.$delqueakyAgent(aid,res => {
						if (res.status == 200) {
							this.getList();
						} else {
							this.$message.error(res.message);
						}
					},
					"");
					},
					""
				);
			},
			onChange(item){
				let dir = this.mech_list.find((i) => item === i.clientKey)
				this.aform.agentName = dir.agentName // 产品名称
				console.log(item)
			},
			closeDia() {
				this.showDia = false;
				this.aform = {
				}
			},
			makeRqs() {
				this.$refs["ruleForm"].validate(valid => {
					if (valid) {
						if(this.isEdit){
							this.loading = true;
							this.$editsqueakyAgent(this.aform,
								res => {
									this.loading = false;
									if (res.status == 200) {
										this.closeDia();
										this.getList();
									} else {
										this.$message.error(res.message);
									}
								},
								""
							);
						}else{
							this.loading = true;
							this.$addsqueakyAgent({
									agentName: this.aform.agentName,
									deviceProvince: this.aform.deviceProvince,
									deviceCity: this.aform.deviceCity,
									clientKey: this.aform.clientKey,
								},
								res => {
									this.loading = false;
									if (res.status == 200) {
										this.closeDia();
										this.getList();
									} else {
										this.$message.error(res.message);
									}
								},
								""
							);
						}
						
						
						
					}
				});
				
				return
				if (this.isEdit) {
					var fm = this.aform;
					this.$editModel(
						fm.oldKey,
						fm.key,
						fm.model,
						res => {
							this.loading = false;
							if (res.status == 200) {
								this.closeDia();
								this.getList();
							} else {
								this.$message.error(res.message);
							}
						},
						() => {
							this.loading = false;
						}
					);
				} else {
					// this.$addModel(
					// 	this.aform.key,
					// 	this.aform.model,
					// 	res => {
					// 		this.loading = false;
					// 		if (res.status == 200) {
					// 			this.closeDia();
					// 			this.getList();
					// 		} else {
					// 			this.$message.error(res.message);
					// 		}
					// 	},
					// 	() => {
					// 		this.loading = false;
					// 	}
					// );
					
					this.$addsqueakyAgent({
							agentName: this.aform.agentName,
							deviceProvince: this.aform.agentName,
							deviceCity: this.aform.deviceCity,
							clientKey: this.aform.clientKey,
						},
						res => {
							if (res.status == 200) {
								this.closeDia();
								this.getList();
							} else {
								this.$message.error(res.message);
							}
						},
						""
					);
					
					
					
					
				}
			},
			addMd() {
				this.isEdit = false;
				this.showDia = true;
			},
			editMd(row) {
				this.isEdit = true;
				this.aform = JSON.parse(JSON.stringify(row)) ;
				this.showDia = true;
			},
			getList() {
				this.loading = true;
				this.$squeakyAgentList({
						page: this.page,
						rows: this.$gRow,
						agentName: this.agentName
					},
					res => {
						this.loading = false;
						if (res.status == 200) {
							this.total = res.total;
							this.tableData = res.data;
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
			},
			get_mech_list(){
				this.$agentCtrlList(res => {
				    if (res.status == 200) {                 
				      this.mech_list = res.data
				      // alert(this.slvl + ' ' + this.vlkey + ' rfrs')
				    }
				  }, '')
			},
			// batchSelected (val) {
			//   this.sRows = val
			// }
		},
		mounted() {
			this.getList();
			this.get_mech_list()
			var _this = this;
			this.pconfig = {
				callback: page => {
					///
					_this.page = page;
					_this.getList();
				}
			};
		}
	};
</script>